import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, TimeUnit, DemurrageTerms, DemurragePayableOver, DemurrageCountingType, CargoQuantityUnit } from "__generated__/graphql";

export const DemurrageSchema: RegistryItem = {
	[AgreementTypeEnum.Demurrage]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.Demurrage,
				demurrageTerms: DemurrageTerms.Ttb2010,
				demurragePayableOver: DemurragePayableOver.Deadweight,
				demurrageCountingType: DemurrageCountingType.ShortNotice,
				cargoQuantityUnit: CargoQuantityUnit.M3,
				timeUnit: TimeUnit.Hour,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
			"agreement.conditions": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
			"calculationMethod.timeUnit": { rules: { hidden: true } },
		},
	},
};
